import React, { useEffect, useState } from 'react';
import "../../config.js";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Rating from '@mui/material/Rating';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';
import { toolGetData } from '../../api/app.js';
import message from '../../lib/message.js';
import GlobalSnackbars from '../../components/GlobalSnackbars.js';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Divider from '@mui/material/Divider';

const AppMgrTool = (props) => {
    const [editData, setEditData] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            const dat = await toolGetData({});
            var arr = [];
            dat.forEach((item, index) => {
                arr.push(item);
            })
            setEditData(arr);
        } catch (err) {
            message.error(err.message || err.toString());
        } finally {
            console.log("end");
        }
    }

    const handleClick = (url) => {
        var tmp_url = url;
        if (tmp_url === undefined || tmp_url === null || tmp_url.length < 1) {
            window.location.href = global.constants.const_url;
        } else {
            window.location.href = tmp_url
        }
    }

    const handleClickBeian = () => {
        window.location.href = "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502018687"
    }
    const handleClickIcp = () => {
        window.location.href = "https://beian.miit.gov.cn"
    }

    return (
        <div>
            <Grid container spacing={0} >

                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" >
                        <Grid item>
                            <List>
                                {editData.map(({ img, toolsname, des, url, tag, stars, version }, index) => (
                                    <React.Fragment key={"k1-" + index.toString()}>
                                        <ListItem button key={"ks-" + index.toString()} onClick={() => { handleClick(url) }}>
                                            <ListItemAvatar>
                                                <Avatar alt="Profile Picture" src={img} />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={toolsname}
                                                secondary={
                                                    <React.Fragment>
                                                        <Typography
                                                            component="span"
                                                            variant="body2"
                                                            color="textPrimary"
                                                        >
                                                            {des}
                                                        </Typography>
                                                        <Typography variant="caption" display="block" gutterBottom>
                                                            {tag}|{version}
                                                        </Typography>
                                                        <Rating name="size-small" value={Number(stars)} size="small" readOnly />
                                                    </React.Fragment>
                                                }
                                            />
                                            <ListItemSecondaryAction>
                                                <IconButton edge="end" aria-label="comments" onClick={() => { handleClick(url) }} >
                                                    <MoreHorizIcon color="primary" />
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                        <Divider variant="inset" component="" />
                                    </React.Fragment>
                                ))}

                                <ListItem button key={"kic5"}>
                                </ListItem>
                                <ListItem button key={"kic"} onClick={() => { handleClickBeian() }} >
                                    <ListItemText
                                        primary={
                                            <div style={{ width: 300, margin: 'auto' }}>
                                                <img src={global.constants.const_img_url+"/my-app/catalog/catalog-gongan.png"} style={{ float: 'left' }} alt={"test"} />
                                                {global.constants.const_app_home_beian}
                                            </div>
                                        }
                                    />
                                </ListItem>
                                <ListItem button key={"kic1"} component="a" onClick={() => { handleClickIcp() }}>
                                    <ListItemText
                                        primary={
                                            <div style={{ textAlign: 'center', fontSize: 12 }}>
                                                {global.constants.const_app_home_icp}
                                            </div>
                                        }
                                    />
                                </ListItem>
                                <ListItem button key={"kic2"}>
                                </ListItem>
                                <ListItem button key={"kic3"}>
                                </ListItem>
                                <ListItem button key={"kic4"}>
                                </ListItem>
                            </List>
                        </Grid>
                    </Grid>
                </Grid>

                <GlobalSnackbars />
            </Grid>
        </div>
    );
}

export default (datasource) => <AppMgrTool datasource={datasource} />;
